// 三語語言包（zh-Hant / zh-Hans / en）放在 src/i18n/locales/，每一語都是完整的，不靠「key 直接當英文」。
// 切換語系沿用舊版做法：寫 localStorage 後整頁重載，所以 lang 在頁面存活期間固定，t() 是普通函式。
// 登入頁等未登入畫面改用 @/i18n/public（只帶小字典），不要引用這支。
// 只載入當下語系的字典（各自打包成獨立檔）。用 top-level await，引用本檔的模組都會等字典到齊才執行，模組層級呼叫 t() 照常可用。
import { createI18n, lang } from './core'

const loaders = {
  'zh-Hant': () => import('./locales/zh-Hant.json'),
  'zh-Hans': () => import('./locales/zh-Hans.json'),
  en: () => import('./locales/en.json'),
}
// 不支援的語系（localStorage 被手動改壞）不載任何字典，畫面顯示 key，同舊版
const dict = loaders[lang] ? (await loaders[lang]()).default : null

export { lang, setLang, SUPPORTED_LANGS } from './core'
export const { t, nt } = createI18n(dict ? { [lang]: dict } : {})

// 把後端代碼翻成文字：對照表查得到才翻譯；查不到（自填值、未知代碼）原樣顯示、不當成缺字警告；null／undefined 顯示空字串。
// 取代 t(ns, Map[x] ?? x)：那種寫法會把原始資料當 key 丟進 t()，畫面相同但開發時會誤報缺字
export const tMapped = (scope, map, value) => (value == null ? '' : Object.hasOwn(map, value) ? t(scope, map[value]) : String(value))
